export class Account
{
    Id!: Number;
    AccountNumber!: string;
    Subsidiary!: string;
    ObjectAccount!: string;
    Description!: string;
    IsActive? : boolean;
    CostCenter!: string;
}